import { CurrencyDispatcher } from '~/flux/dispatchers';
import CurrencyStore from '~/flux/stores/CurrencyStore';
import mutationClaimReferralCode from '~/graphql/player/mutationClaimReferralCode';
import { logError } from '~/logger';
import messages, { ReferralsStoreMessage } from '../messages';
import { GraphQlRequestError } from '~/graphql/graphqlClient';

export default async function claimReferralCode({
  playerId,
  code,
  emit,
}: {
  playerId: string | null;
  code: string;
  emit: (message: ReferralsStoreMessage, data?: unknown) => void;
}) {
  if (!playerId) throw new Error('playerId required');
  try {
    const result = await mutationClaimReferralCode({ playerId, code });
    const reward = result.claim_reward as Record<string, unknown>;
    const { pixieDust, gold } = CurrencyStore.getAll();

    if (typeof reward.currency1 === 'number') {
      CurrencyDispatcher.handleCurrencyAction({
        actionType: CurrencyDispatcher.NEW_CURRENCY_BALANCE,
        currency1: pixieDust + reward.currency1,
      });
    }
    if (typeof reward.currency2 === 'number') {
      CurrencyDispatcher.handleCurrencyAction({
        actionType: CurrencyDispatcher.NEW_CURRENCY_BALANCE,
        currency2: gold + reward.currency2,
      });
    }

    emit(messages.CLAIM_SUCCESS, reward);
  } catch (err) {
    const key = (err as GraphQlRequestError)?.errors?.[0]?.message;
    emit(messages.CLAIM_ERROR, key);
    logError(err, { module: 'ReferralsStore', func: 'claimReferralCode' });
  }
}
